import {Component} from '@angular/core';
import {BaseActivityComponent} from '../base-activity.component';
import {Observable, of} from 'rxjs';
import {AudioActivityGranule} from '@modules/activities/core/models/activities/typologies/audio-activity.granule';

@Component({
    selector: 'app-audio',
    templateUrl: './audio.component.html'
})
export class AudioComponent extends BaseActivityComponent<AudioActivityGranule> {
    public questionObject: AudioActivityGranule['attributes']['reference'];
    public audioUrl: string;
    public imageUrl: string;

    protected setContentData(activityAttributes: AudioActivityGranule['attributes']): void {
        this.questionObject = activityAttributes.reference;
        this.instruction = this.questionObject.instruction;
        this.wording = this.questionObject.wording;
        this.instructionAudio = this.questionObject.instructionAudio;
        this.wordingAudio = this.questionObject.wordingAudio;

        if(this.questionObject.activity_content.length > 0) {
            const media = this.questionObject.activity_content[0];
            this.imageUrl = media.image;
            this.audioUrl = media.media;
        } else {
            throw new Error('No media content found');
        }
    }

    /**
     * create answer entered by the user.
     * no need to create answer because answer already exist.
     * method needed for save in baseActivityComponent
     * @protected
     */
    protected saveAnswer(): Observable<number[]> {
        return of(null);
    }

    protected reviewAnswer(): void {
        throw new Error('Method not implemented.');
    }

    protected seeAnswerSolution(): void {
        throw new Error('Method not implemented.');
    }

    protected checkAnswer(): void {
        throw new Error('Method not implemented.');
    }

    protected setAnswer(): void {
        throw new Error('Method not implemented.');
    }

    protected  getGrade(): {oldGrade: number, newGrade: number} {
        throw new Error('Method not implemented.');
    }

    protected getAttempts(): number {
        throw new Error('Method not implemented.');
    }

    protected validate(): void {
        throw new Error('Method not implemented.');
    }
}
